// Базовые типы для API

export interface ApiResponse<T = unknown> {
    data: T;
    result?: string;
    meta?: {
        message?: string;
        errors?: Record<string, string[]>;
        [key: string]: unknown;
    };
}

export interface ApiError {
    status: number;
    data: {
        message?: string;
        errors?: Record<string, string[]>;
        [key: string]: unknown;
    };
}

// Типы для Applications
export interface Application {
    id: number;
    status_id?: number;
    duration?: number;
    created_at?: string;
    updated_at?: string;
    resource?: unknown;
    refuseReason?: unknown;
    statusHistory?: unknown[];
    mainContact?: Contact;
    assignedContacts?: Array<{ contact: Contact }>;
    [key: string]: unknown;
}

export interface ApplicationListParams {
    sortId?: number | null;
    isArchive: boolean;
}

export interface ApplicationByIdParams {
    id: number;
    isArchive: boolean;
}

export interface UpdateApplicationParams {
    id: number;
    data: Record<string, unknown>;
}

export interface UpdateApplicationFieldParams {
    id: number;
    field: string;
    value: unknown;
}

// Типы для Contacts
export interface Contact {
    id: number;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string | null;
    is_archive?: number | boolean;
    refuse_reason_id?: number | null;
    requisite?: unknown;
    requisite_bank?: unknown;
    files?: unknown[];
    [key: string]: unknown;
}

export interface SetContactArchivedParams {
    contactId: number | string;
    isArchived: boolean | number;
    refuseReasonId?: number;
}

// Типы для Clients
export interface Client {
    id: number;
    manager_id?: number;
    created_at?: string;
    updated_at?: string;
    atonUsers?: unknown[];
    multiple_managers?: unknown[];
    mainContact?: Contact;
    financeGroups?: unknown[];
    oppositeFinanceGroup?: unknown;
    [key: string]: unknown;
}

export interface ClientListParams {
    clientId?: string | number | null;
    isArchive?: boolean;
    sortId?: number | null;
    isFullGroup?: boolean;
}

export interface UpdateClientFieldParams {
    clientId: number | string;
    params: Record<string, unknown>;
}

export interface BindClientParams {
    accountsToBind: unknown[];
    queryParamsList: Record<string, unknown>;
    shareUser?: boolean;
}

export interface UserFinanceGroupParams {
    userId: number | string;
}

// Типы для Tasks
export interface Task {
    id: number;
    comment?: string;
    type_id?: number;
    end_at?: string;
    start_at_datetime?: string;
    end_at_datetime?: string;
    [key: string]: unknown;
}

export interface CreateTaskParams {
    comment?: string;
    type_id?: number;
    end_at?: string;
    [key: string]: unknown;
}

export interface UpdateTaskParams {
    id: number;
    data: Record<string, unknown>;
}

// Типы для Services
export interface Service {
    id: number;
    is_paid?: number | boolean;
    is_archived?: number | boolean;
    client_id?: number;
    clients?: Array<{
        client?: Client;
        payments?: unknown[];
    }>;
    [key: string]: unknown;
}

export interface ServiceListParams {
    clientId?: number;
    isArchived?: boolean | null;
}

export interface UpdateServicePaidParams {
    ids: number[];
    isPaid: boolean;
}

export interface AssignServicesParams {
    valuationsList?: unknown[];
    apiParams: Record<string, unknown>;
}

export interface UpdateServiceArchiveParams {
    id: number;
    isArchived: boolean;
}

export interface CalculateSuccessFeeParams {
    clientId: number | string;
}

export interface GenerateServiceExcelParams {
    data: unknown;
    client: string;
    service: string;
}

export interface ServicesOnConfirmationParams {
    clientId: string | number;
}

// Типы для Files
export interface File {
    id: number;
    original_name?: string;
    file_name?: string;
    categories?: Category[];
    [key: string]: unknown;
}

export interface Category {
    id: number;
    name?: string;
    parent_id?: number | null;
    order?: number;
    children?: Category[];
    [key: string]: unknown;
}

// Типы для Portfolio
export interface Portfolio {
    account_number: string;
    type_id?: string;
    [key: string]: unknown;
}

export interface AverageValuationParams {
    id: string | number;
    userId?: string | number | (string | number)[] | null;
    dates?: {
        start: string;
        end: string;
    };
    accountNumber?: number | string | null;
}

export interface SingleUserAccountParams {
    userId: number | string;
}

// Типы для Settings
export interface RefuseReason {
    id: number;
    name?: string;
    is_active?: boolean;
    [key: string]: unknown;
}

export interface UpdateRefuseReasonParams {
    id: number;
    active: boolean;
}

// Типы для Permissions
export interface Permission {
    id: number;
    name?: string;
    slug?: string;
    [key: string]: unknown;
}

// Типы для Employees
export interface Employee {
    id: number;
    name?: string;
    email?: string;
    roles?: Array<{ slug: string }>;
    [key: string]: unknown;
}
